export class Template {
    public id: number|null = null;
    public name: string|null = null;
    public body: string|null = null;
    public css: string|null = null;
    public scss: string|null = null;
    public ad_id: number|null = null;
}

